import SEO, { SEOProps } from "./SEO";

export { SEO, SEOProps };

export default SEO;
